import React from 'react';
import './ShippingInfo.css';
import parcelIcon from '../assets/images/shipping/parcel-icon.svg';
import palletIcon from '../assets/images/shipping/pallet-icon.svg';
import warehouseIcon from '../assets/images/shipping/warehouse-icon.svg';
import contactIcon from '../assets/images/shipping/contact-icon.svg';

// Placeholder comment: The actual image files should be placed in the respective folders
// You'll need to upload these files yourself:
// - parcel-icon.svg: An icon representing parcel delivery (small truck)
// - pallet-icon.svg: An icon representing pallet delivery (larger truck)
// - warehouse-icon.svg: An icon representing warehouse pickup
// - contact-icon.svg: An icon representing customer service/contact
// - delivery-truck.png: An image of the orange delivery truck shown in the header

const ShippingInfo = () => {
  return (
    <div className="shipping-info-container">
      <header className="shipping-header">
        <h1 className="shipping-title">Shipping & Delivery<br />Information</h1>
       
        <div className="logo-container">
          <img 
            src="/square-foot-logo.svg" 
            alt="Squarefoot Flooring" 
            className="flooring-deals-logo" 
          />
        </div>
      </header>
      
      <div className="intro-section">
        <p className="shipping-intro">
          At FlooringDeals, we offer flexible delivery and pickup options to meet your needs across Canada. 
          Whether you're ordering a few tools or pallets of flooring, we make getting your products easy and affordable.
        </p> 
      </div>

      <div className="shipping-options">
        <div className="shipping-option parcel">
          <div className="option-header">
            <div className="option-icon">
            <img src={'/assets/images/shipping/truckIcon.svg'} alt="Pallet Delivery" className="option-icon" />
            </div>
            <div className="option-title">
              <h2>Parcel Deliveries</h2>
              <h3>Tools & Accessories</h3>
            </div>
          </div>
          <div className="option-details">
            <p>Delivery Time: 2 to 4 business days</p>
            <p>Cost: $9.95 or FREE for orders over $100</p>
            <p>Oversized item fee: $34.95</p>
          </div>
        </div>
    
        <div className="shipping-option pallet">
          <div className="option-header">
            <img src={'/assets/images/shipping/truckIcon.svg'} alt="Pallet Delivery" className="option-icon" />
            <div className="option-title">
              <h2>Pallet Deliveries</h2>
              <h3>Flooring & Heavy Items</h3>
            </div>
          </div>
          <div className="option-details">
            <p>Delivery Time: 3 to 5 business days</p>
            <p>Cost: Starts at $80.00+ (varies by region)</p>
            <p>Add postal code at checkout to calculate exact cost</p>
          </div>
        </div>

        <div className="shi">
          <img 
            src="/assets/images/shipping/truck.png" 
            alt="hdmovietoday.xyz Delivery Service" 
            className="truck-image" 
          />
        </div>
      </div>

      <hr className="section-divider" />

      <div className="warehouse-section">
        <div className="warehouse-header">
         
          <h2>Warehouse Pickups – 15 Locations Across Canada</h2>
        </div>
        
        <p className="pickup-intro">Free pickup from warehouse terminals :</p>
        
        <div className="warehouse-locations">
          
            <div className="first-column">
              <ul className="first-column-list">
              <li>6845 Invader Crescent, Mississauga, <b>ON,</b> L5T 2B7</li>
              <li>881 Belgrave Way, Delta, <b>BC,</b> V3M 5R8</li>
              <li>5620 68 Ave Southeast, Calgary, <b>AB,</b> T2C 5L1</li>
              <li>510 Ave Orly, Dorval, <b>QC,</b> H9P 2V2</li>
              <li>11560 186 Street Northwest, Edmonton, <b>AB,</b> T5S 2Y2</li>
              <li>9460 Mitch Owens Road, Ottawa, <b>ON,</b> K0A 1V0</li>
              <li>123 Wheatfield Road, Winnipeg, <b>MB,</b> R3C 2E6</li>
              <li>1821 Wendell Street, Dalton, <b>GA,</b> 30721</li>
              <li>3960 Commerce Road, London, <b>ON,</b> N6N 1P8</li>
              <li>445 Ave St Jean Baptiste, Québec City, <b>QC,</b> G2E 5N7</li>
              <li>110-245 Beaver Lake Court, Kelowna, <b>BC,</b> V4V 1S5</li>
              <li>850 Rue Vadnais, Granby, <b>QC,</b> J2J 1A7</li>
              <li>761 66th Street East, Unit 200, Saskatoon, <b>SK,</b> S7P 0E4</li>
              <li>645 McLeod Street, Regina, <b>SK,</b> S4N 4Y2</li>
              <li>15 Elliott Ave, Barrie, <b>ON,</b> L4N 4V6</li>
              </ul>
          </div>
         
          <div className="second-column">
            <img 
              src="assets/images/shipping/boxes.png" 
              alt="hdmovietoday.xyz warehouse boxes" 
              className="boxes-image" 
            />
          </div>
        </div>
      </div>

      <div className="custom-quote">
        <div className="quote-icon">
          <img src={'/assets/images/shipping/white-truck.svg'} alt="Contact Icon" />
        </div>
        <div className="quote-content">
          <p className="quote-text">
            Need a Custom Shipping Quote? Contact us directly for rural areas, oversized deliveries, or special requests.
         
          </p>
        </div>
        <a href="/contact" className="contact-link">Contact Us.</a> 
      </div>
    </div>
  );
};

export default ShippingInfo;
